export const CHANGE_CURRENT_PAGE = 'alerts/CHANGE_CURRENT_PAGE'
export const CHANGE_PAGE_SIZE = 'alerts/CHANGE_PAGE_SIZE'
export const FETCH_ALERTS_LIST = 'alerts/FETCH_ALERTS_LIST'
